import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

import { getPlatformManageGetPlatformRegistryResponseMock } from 'shared/base';

import { getCustomHandlerLoginStatus, getCustomHandlerRegisterPlatformStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformManageGetPlatformRegistryMockHandler = () => {
  return http.get('*/manage/register-platform', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    if (!getCustomHandlerRegisterPlatformStatus()) {
      return new HttpResponse(null, { status: 404 });
    }

    return HttpResponse.json(
      {
        ...getPlatformManageGetPlatformRegistryResponseMock(),
        next_activation_at: `${faker.date.future().toISOString().split('.')[0]}Z`,
      },
      {
        status: 200,
      },
    );
  });
};
